import { ExportRequest } from '@components/App/Modal/Share/components/Export/components/ExportRequest'
import { Plug } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useProjectAccess } from '@/hooks'
import { EXPORT_PERMISSION } from '@/permissions/project/definitions'
import {
  ExportCsv,
  ExportDoc,
  ExportFigma,
  ExportPdf,
  ExportPng,
  ExportPrompt,
  ExportSitemapXml,
  ExportTxt,
  ExportWp,
  ExportXls,
  ExportXml,
} from './components'
import css from './styles.module.css'

export const Export: React.FC = () => {
  const { hasAccess: exportable } = useProjectAccess(
    EXPORT_PERMISSION.FILE_FORMATS
  )

  return (
    <div>
      <div className={css.container}>
        <ExportFigma />
        <ExportPrompt />
        <ExportWp />
        <ExportSitemapXml />
        <ExportXml exportable={exportable} />
        <ExportPdf exportable={exportable} />
        <ExportPng exportable={exportable} />
        <ExportCsv exportable={exportable} />
        <ExportXls exportable={exportable} />
        <ExportTxt exportable={exportable} />
        <ExportDoc exportable={exportable} />
        <ExportRequest />
      </div>

      <a
        className={css.tutorial_link}
        href="https://help.octopus.do/article/140-develop-your-own-plugin"
        target="_blank"
        rel="noopener"
      >
        <Plug />
        Develop your own plugin
      </a>
    </div>
  )
}
